import { Component, Input, effect } from '@angular/core';
import { NavigationService } from '@app/finxone-web-frontend/app/lib/services/navigation-service/navigation.service';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { Select } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-multi-icon-quick-link',
  templateUrl: './multi-icon-quick-link.component.html',
  styleUrls: ['./multi-icon-quick-link.component.scss'],
})
export class MultiIconQuickLinkComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() multiIconQuickLinksData: {
    title: string;
    url: string | undefined;
    pageId: string | undefined;
    icon: string | undefined;
    role: string | undefined;
    zone: string | undefined;
    externalLink: string | undefined;
    browserBehaviour: string | undefined;
  };
  @Input() contentStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  @Input() leftIcon: string;
  @Input() rightIcon: string;
  @Input() headerSubheaderTemplate: string;
  @Input() globalStylingClass = '';
  @Input() isAllowedGlobalStyling = false;
  @Input() public iconStyle: baseCssConfigStyle;
  @Select(RoleState.getRole)
  roles!: Observable<RoleStateModel>;
  roleInfo: RoleStateModel;
  public disableButton = false;

  constructor(
    private workflowFormsService: WorkflowFormsService,
    private navigationService: NavigationService,
  ) {
    this.roles.pipe(takeUntil(this.destroy$)).subscribe((roles) => {
      this.roleInfo = roles;
    });

    effect(() => {
      const pageFormsValid = this.workflowFormsService.currentPageFormsValid();
      this.disableButton = !pageFormsValid;
    });
  }

  goToLink(url: string | undefined, role: string | undefined) {
    this.navigationService.navigateByPageUrl({
      url,
      targetRole: role,
      currentRole: this.roleInfo.role,
      zone: this.multiIconQuickLinksData.zone,
      externalLink: this.multiIconQuickLinksData?.externalLink,
      browserBehaviour: this.multiIconQuickLinksData?.browserBehaviour,
    });
  }
}
